var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKebabMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3556_229492)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 13C16.825 13 17.5 12.325 17.5 11.5C17.5 10.675 16.825 10 16 10C15.175 10 14.5 10.675 14.5 11.5C14.5 12.325 15.175 13 16 13ZM16 14.5C15.175 14.5 14.5 15.175 14.5 16C14.5 16.825 15.175 17.5 16 17.5C16.825 17.5 17.5 16.825 17.5 16C17.5 15.175 16.825 14.5 16 14.5ZM14.5 20.5C14.5 19.675 15.175 19 16 19C16.825 19 17.5 19.675 17.5 20.5C17.5 21.325 16.825 22 16 22C15.175 22 14.5 21.325 14.5 20.5Z",
    fill: "#696F88"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#C2C7D0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3556_229492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKebabMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/kebab_menu.aa05f88e9db1946e229d5c1b6e4d3624.svg";